import _ from 'lodash';
export const name = 'NEV.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const cellValue = _.get(row, prop);
    const items = _.map(cellValue, (content) => {
        return <span 
        // @ts-ignore
        domProps={{ innerHTML: _highlightMixin_hlText(content.node_name_tran) }}/>;
    });
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {items}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const result = _.map(row[column.property] || [], item => {
        return item;
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
